import {Component, OnInit} from '@angular/core';
import {Observable, of} from "rxjs";
import {Address} from "@spartacus/core";
import {GonvarriB2BUnit} from "../../core/models/gonvarri-b2b-unit.model";
import { GonvarriMyCompanyAddressesAdapter } from 'src/app/core/adapters/gonvarri-my-company-addresses.adapter';

@Component({
    selector: 'app-gonvarri-my-company-addresses-table',
    templateUrl: './gonvarri-my-company-addresses-table.component.html',
    styleUrl: './gonvarri-my-company-addresses-table.component.scss',
    standalone: false
})
export class GonvarriMyCompanyAddressesTableComponent implements OnInit {

  protected myUnit$: Observable<GonvarriB2BUnit> = of({} as GonvarriB2BUnit);
  protected defaultAddress$: Observable<Address> = of({} as Address);

  constructor(
    private adapter: GonvarriMyCompanyAddressesAdapter
  ) {}

  ngOnInit() {
    this.myUnit$ = this.adapter.getAddresses();
    this.myUnit$.subscribe((unit) => {
      const DEFAULT_ADDR = unit.defaultAddress;
      this.defaultAddress$ = of(DEFAULT_ADDR ?? {} as Address);
    })
  }

  defineAsDefault(event: MouseEvent, address: Address): void {
    this.defaultAddress$ = this.adapter.defineDefaultAddress(address);
  }

}
